import api from "./index"
import { IGetReportQueryParams } from "types/report"

const getReport = (params: IGetReportQueryParams) => {
  const {
    fromDate,
    toDate,
    carWashIds,
    statusIds,
    boxIds,
    washerIds,
    reservationSourceId,
  } = params

  let query = ""

  if (fromDate !== undefined) {
    query += `&fromDate=${fromDate}`
  }

  if (toDate !== undefined) {
    query += `&toDate=${toDate}`
  }

  if (carWashIds !== undefined && carWashIds.length > 0) {
    carWashIds.forEach((id: number, i: number) => {
      query += `&carWashIds[${i}]=${id}`
    })
  }

  if (statusIds !== undefined && statusIds.length > 0) {
    statusIds.forEach((id: number, i: number) => {
      query += `&statusIds[${i}]=${id}`
    })
  }
  if (boxIds !== undefined && boxIds.length > 0) {
    boxIds.forEach((id: number, i: number) => {
      query += `&boxIds[${i}]=${id}`
    })
  }
  if (washerIds !== undefined && washerIds.length > 0) {
    washerIds.forEach((id: number, i: number) => {
      query += `&washerIds[${i}]=${id}`
    })
  }
  if (reservationSourceId !== undefined) {
    query += `&reservationSourceId=${reservationSourceId}`
  }

  return api.get(`/report/getReport?${query}`, {
    headers: {
      "Content-Disposition": "attachment;filename=go.csv",
      "Content-Type": "application/csv",
    },
  })
}

const getReportStatuses = () =>
  api.get("Reservation/GetReservationStatuseGroups")

const getReportSources = () => api.get("Reservation/GetReservationSources")

const getReportWashers = (data: number[]) =>
  api.post("Report/getWashersForFilter", data)

const getReportBoxes = (data: number[]) => api.post("Report/getBoxCount", data)

const getReportPreview = (params: IGetReportQueryParams) => {
  const {
    fromDate,
    toDate,
    carWashIds,
    statusIds,
    boxIds,
    washerIds,
    reservationSourceId,
  } = params

  let query = ""

  if (fromDate !== undefined) {
    query += `&fromDate=${fromDate}`
  }

  if (toDate !== undefined) {
    query += `&toDate=${toDate}`
  }

  if (carWashIds !== undefined && carWashIds.length > 0) {
    carWashIds.forEach((id: number, i: number) => {
      query += `&carWashIds[${i}]=${id}`
    })
  }

  if (statusIds !== undefined && statusIds.length > 0) {
    statusIds.forEach((id: number, i: number) => {
      query += `&statusIds[${i}]=${id}`
    })
  }
  if (boxIds !== undefined && boxIds.length > 0) {
    boxIds.forEach((id: number, i: number) => {
      query += `&boxIds[${i}]=${id}`
    })
  }
  if (washerIds !== undefined && washerIds.length > 0) {
    washerIds.forEach((id: number, i: number) => {
      query += `&washerIds[${i}]=${id}`
    })
  }
  if (reservationSourceId !== undefined) {
    query += `&reservationSourceId=${reservationSourceId}`
  }

  return api.get(`/report/getReportPreview?${query}`)
}

export default {
  getReport,
  getReportStatuses,
  getReportSources,
  getReportBoxes,
  getReportWashers,
  getReportPreview,
}
